module.exports = __webpack_public_path__ + "img/C08TechBountifulHarvest_ua.e53e594b.webp";